(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketplaceDetailController', MarketplaceDetailController);

    MarketplaceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Marketplace'];

    function MarketplaceDetailController($scope, $rootScope, $stateParams, entity, Marketplace) {
        var vm = this;

        vm.marketplace = entity;

        var unsubscribe = $rootScope.$on('tikonApp:MarketplaceUpdate', function (event, result) {
            vm.marketplace = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
